import { PlusOutlined } from '@ant-design/icons';
import { Modal, UploadProps } from 'antd';
import React, { useState } from 'react';
import { getBase64 } from '../../../utils/files';
import { TAUploadText, TAUpload_ } from './styles/ta-upload';
import { useTheme } from 'styled-components';

interface ITaUploadProps {
	btnText: string;
}

export const TAUpload: React.FC<ITaUploadProps & UploadProps> = ({ btnText, maxCount = 1, fileList, ...restProps }) => {
	const [previewVisible, setPreviewVisible] = useState(false);
	const [previewImage, setPreviewImage] = useState('');
	const theme = useTheme();
	const handlePreview = async (file: any) => {
		if (!file.url && !file.preview) {
			file.preview = await getBase64(file.originFileObj);
		}

		setPreviewImage(file.url || file.preview);

		setPreviewVisible(true);
	};

	const handleCancel = () => {
		setPreviewVisible(false);
	};

	return (
		<>
			<TAUpload_ onPreview={handlePreview} maxCount={maxCount} {...restProps}>
				{fileList && fileList.length === maxCount ? null : (
					<TAUploadText>
						<PlusOutlined />
						<div className="mt-2">{btnText}</div>
					</TAUploadText>
				)}
			</TAUpload_>
			{fileList && fileList.length > maxCount ? (
				<span style={{ color: theme.TA_WARNING }}>Only a maximum of {maxCount} images allowed!</span>
			) : null}

			<Modal className="ta-modal" open={previewVisible} footer={null} onCancel={handleCancel}>
				<img style={{ width: '100%' }} src={previewImage} />
			</Modal>
		</>
	);
};
